import { jsx as _jsx } from "react/jsx-runtime";
import { HcAlert } from '@hotmart-org-ca/cosmos-web/dist/react/hc-alert';
const Alert = ({ children, className, dismissible, dismissButtonAriaLabel, context = 'info' }) => {
    return (_jsx(HcAlert, { class: className, context: context, dismissible: dismissible, dismissButtonAriaLabel: dismissButtonAriaLabel, children: children }));
};
export default Alert;
